import { InnerBlocks } from '@wordpress/block-editor';

export default function PostTemplateSave() {
	return <InnerBlocks.Content />;
}
